import { render, staticRenderFns } from "./exam-results-dashboard-table-component.vue?vue&type=template&id=7245da7f&scoped=true&"
import script from "./exam-results-dashboard-table-component.vue?vue&type=script&lang=ts&"
export * from "./exam-results-dashboard-table-component.vue?vue&type=script&lang=ts&"
import style0 from "./exam-results-dashboard-table-component.vue?vue&type=style&index=0&id=7245da7f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7245da7f",
  null
  
)

export default component.exports